import { useEffect, useState } from "react";
import { CalendarOff, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { fetchHolidays, saveHolidays } from "../lib/api";
import { dayLabel } from "../lib/pickerSheet";

const UK_BANK_HOLIDAYS = [
  ["2025-01-01", "New Year's Day"], ["2025-04-18", "Good Friday"], ["2025-04-21", "Easter Monday"], ["2025-05-05", "Early May bank holiday"],
  ["2025-05-26", "Spring bank holiday"], ["2025-08-25", "Summer bank holiday"], ["2025-12-25", "Christmas Day"], ["2025-12-26", "Boxing Day"],
  ["2026-01-01", "New Year's Day"], ["2026-04-03", "Good Friday"], ["2026-04-06", "Easter Monday"], ["2026-05-04", "Early May bank holiday"],
  ["2026-05-25", "Spring bank holiday"], ["2026-08-31", "Summer bank holiday"], ["2026-12-25", "Christmas Day"], ["2026-12-28", "Boxing Day (substitute)"],
].map(([date, label]) => ({ date, label }));

export const HolidayManager = () => {
  const [items, setItems] = useState(null);
  const [date, setDate] = useState("");
  const [label, setLabel] = useState("");
  useEffect(() => { fetchHolidays().then(setItems).catch(() => setItems([])); }, []);
  const save = async (next, msg) => {
    try { setItems(await saveHolidays(next)); if (msg) toast.success(msg); } catch { toast.error("Could not save"); }
  };
  const add = () => {
    if (!date) return toast.error("Pick a date");
    save([...items, { date, label: label || "Shutdown" }], "Day added");
    setDate(""); setLabel("");
  };
  if (!items) return null;
  return (
    <div className="max-w-5xl mx-auto px-6 pb-16 fade-up" data-testid="holiday-manager">
      <p className="label-mono mb-3">Bank holidays & shutdown days</p>
      <div className="panel p-5">
        <p className="text-sm text-slate-400 mb-4">These dates are not counted as absent days for any picker.</p>
        <div className="flex flex-wrap items-center gap-3">
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="holiday-date-input" className="h-9 w-[160px] bg-[#0B0F19] border-slate-700 text-slate-100 font-mono text-xs [color-scheme:dark]" />
          <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Label (e.g. Site shutdown)" data-testid="holiday-label-input" className="h-9 w-[240px] bg-[#0B0F19] border-slate-700 text-slate-100 text-xs" />
          <button data-testid="holiday-add-button" onClick={add} className="inline-flex items-center gap-2 text-xs px-3 py-2 rounded-md bg-ep hover:bg-ep-hover text-white"><Plus className="h-3.5 w-3.5" /> Add day</button>
          <button data-testid="holiday-add-uk" onClick={() => save([...items, ...UK_BANK_HOLIDAYS], "UK bank holidays 2025–2026 added")} className="inline-flex items-center gap-2 text-xs px-3 py-2 rounded-md border border-slate-700 text-slate-300 hover:bg-slate-800"><CalendarOff className="h-3.5 w-3.5" /> Add UK bank holidays 2025–26</button>
        </div>
        <div className="mt-5 flex flex-wrap gap-2" data-testid="holiday-list">
          {items.length === 0 && <p className="text-xs text-slate-500">No days added yet.</p>}
          {items.map((h) => (
            <span key={h.date} data-testid={`holiday-${h.date}`} className="inline-flex items-center gap-2 text-xs pl-3 pr-1 py-1 rounded-full border border-slate-700 bg-[#0B0F19] text-slate-200">
              <span className="font-mono">{dayLabel(h.date)} {h.date.slice(0, 4)}</span><span className="text-slate-500">{h.label}</span>
              <button data-testid={`holiday-remove-${h.date}`} onClick={() => save(items.filter((x) => x.date !== h.date))} className="p-1 rounded-full hover:bg-slate-700"><Trash2 className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
